import * as React from "react";
import { AuthContext } from "./index";

export const useAuth = () => React.useContext(AuthContext);
